export const t = window.useAvalLocal?.("aval");
